import { useLanguage } from "@/i18n/LanguageContext";

const Process = () => {
  const { t } = useLanguage();
  const steps = t("process.steps");
  const deliverables = t("process.deliverables");

  return (
    <section className="blueprint-grid border-t border-slate-200 bg-white py-20 sm:py-28" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-sky-700" data-testid="process-badge">
          {t("process.badge")}
        </p>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl" data-testid="process-title">
          {t("process.title")}
        </h2>

        <div className="mt-12 grid gap-px overflow-hidden rounded-lg border border-slate-200 bg-slate-200 sm:grid-cols-2 lg:grid-cols-5">
          {steps.map((s, i) => (
            <div key={s.title} className="group bg-white p-7 transition-colors duration-300 hover:bg-sky-50/60" data-testid={`process-step-${i + 1}`}>
              <span className="font-display text-4xl font-bold text-sky-600/25 transition-colors duration-300 group-hover:text-sky-600">
                {i + 1}
              </span>
              <h3 className="mt-4 font-display text-base font-bold text-slate-900">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-3" data-testid="process-deliverables">
          <span className="font-mono text-xs uppercase tracking-widest text-slate-500">{t("process.deliverablesLabel")}</span>
          {deliverables.map((d) => (
            <span key={d} className="rounded-full border border-slate-200 bg-slate-50 px-3.5 py-1.5 font-mono text-xs uppercase tracking-widest text-slate-600">
              {d}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
